angular.module('salesPath2')
.service('shortPathHelper', [
  function(){
    var ShortPathHelper = function() {
        var self = this;
        /**
         * dane dla szablonu i kontrolera
         * @type {Object}
         */
        this.data = {
            context: 'etx',
            etxVehicleIdentified: true,
            registrationTypes: [],
            initiated: false
        };         

        /**
         * reakcja na akcje w aplikacji
         * @param  {String} actionName nazwa wykonanej akcji
         */
        this._afterAction = function(actionName) {
            switch (actionName) {
                case 'showVehicleNonEtx':
                    self.data.context = 'nonetx'; 
                    break;
                case 'shortPathVehicleSelected':
                    self.data.context = 'etx'; 
                    break;
                default:
            }
        };

        this.clearData = function() {
            self.data.context = 'etx'; 
        };

        this.replaceZerosWithNulls = function(vehicle) {
            // iterate over mainDataContainer.vehicles[mainDataContainer.selectedVehicle] properties, check for each if value is '0' and set it to null
            angular.forEach(vehicle, function (value, key) {
                if (angular.isArray(value) && (value[0] === '0' || value[0] === 0)) {
                    vehicle[key][0] = null;
                } else if (!angular.isArray(value) && (value === '0' || value === 0)) {
                  vehicle[key] = null;
                }
            });
            angular.forEach(vehicle.dynamicValues, function (value, key) {
                if (value === '0' || value === 0) {
                    vehicle.dynamicValues[key] = null;
                }
            });
        };

    };
    return new ShortPathHelper();
}])
.run(['CONFIG', 'shortPathHelper', 'actionHelper',
  function(CONFIG, shortPathHelper, actionHelper) {
    actionHelper.registerHelper('shortPathHelper', shortPathHelper, ['shortPathVehicleSelected', 'showVehicleNonEtx']);
  }
]);